import { render } from "./ArticleVue.vue?vue&type=template&id=fbe7defa&scoped=true"
const script = {}

import "../assets/css/article.css?vue&type=style&index=0&id=fbe7defa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe7defa"]])

export default __exports__